import { RootSelector, RootStore, getStore } from '../../reducers';
import { createSelector } from '@reduxjs/toolkit';
import { DictionaryEntry, DictionaryItem, DictionaryName, FiltersCacheShape } from './model';

export const getFiltersCache: RootSelector<FiltersCacheShape> = createSelector(
  getStore,
  (state) => state.filtersCache,
);

// Не селектор, а функция от параметров: ключ вычисляется в лисенере из текущих фильтров,
// поэтому мемоизация здесь не нужна и только мешала бы.
export function getCachedDictionary<N extends DictionaryName>(
  state: RootStore,
  dict: N,
  key: string,
): DictionaryEntry<DictionaryItem<N>> | undefined {
  return getFiltersCache(state)[dict][key] as DictionaryEntry<DictionaryItem<N>> | undefined;
}
